import { Grid } from '@material-ui/core'
import { useIntl } from 'react-intl'
import SearchBox from './SearchBox'
import { TabsEnum } from '@src/routes/Configurators/products/TubesMTORedesign/ProductsConfiguration'
import {
  useProductFromQueryParam,
  SemiConfigFormValues,
  shouldRenderPerformanceGuaranteeLink,
  shouldRenderSearchBoxWithoutTabsOnStep1,
} from './ProductsConfiguration'
import { useFormikContext } from 'formik'
import CommonTabs, { CommonTab } from '@src/components/Common/CommonTabs'
import MultipleProductEntry from './MultipleProductEntry'
import PerformanceGuaranteeModal from '@src/routes/Configurators/components/PerformanceGuaranteeModal'

const Search = () => {
  const intl = useIntl()
  const product = useProductFromQueryParam()
  const formik = useFormikContext<SemiConfigFormValues>()
  const onTabChange = (tab: TabsEnum) => {
    formik.setFieldValue('activeSearchTab', tab, false)
  }

  const renderAdditionalLinkOnStep1 =
    shouldRenderPerformanceGuaranteeLink(product)
  const renderSearchBoxWithoutTabsOnStep1 =
    shouldRenderSearchBoxWithoutTabsOnStep1(product)

  const tabs: CommonTab[] = [
    {
      label: intl.formatMessage({
        id: 'CONF_MANUAL_SEARCH_crisprgrna',
        defaultMessage: 'Manual Search',
      }),
      component: <SearchBox />,
      id: 'single-product-entry',
      selectCallback: () => onTabChange(TabsEnum.SequenceEntry),
    },
    {
      label: intl.formatMessage({
        id: 'CONF_UPLOAD_QUERIES_crisprgrna',
        defaultMessage: 'Upload Queries',
      }),
      component: <MultipleProductEntry />,
      id: 'multiple-product-entry',
      selectCallback: () => onTabChange(TabsEnum.MultipleEntry),
    },
  ]
  const tab = formik.values.activeSearchTab === TabsEnum.MultipleEntry ? 1 : 0
  const getComponent = () => {
    if (renderSearchBoxWithoutTabsOnStep1) {
      return <SearchBox />
    }
    return (
      <CommonTabs
        tabs={tabs}
        hideDivider
        activeTabIndex={tab}
        additionalLink={
          renderAdditionalLinkOnStep1 ? <PerformanceGuaranteeModal /> : null
        }
      />
    )
  }
  return (
    <Grid container spacing={6}>
      <Grid item xs={12}>
        {getComponent()}
      </Grid>
    </Grid>
  )
}

export default Search
